import { render, staticRenderFns } from "./itemCatPhotoUpload.vue?vue&type=template&id=3e1bfd9e&scoped=true"
import script from "./itemCatPhotoUpload.vue?vue&type=script&lang=js"
export * from "./itemCatPhotoUpload.vue?vue&type=script&lang=js"
import style0 from "./itemCatPhotoUpload.vue?vue&type=style&index=0&id=3e1bfd9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1bfd9e",
  null
  
)

export default component.exports